import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronDown16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.46967 6.53033L3.53033 5.46967L8 9.93934L12.4697 5.46967L13.5303 6.53033L8 12.0607L2.46967 6.53033Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronDown16.displayName = 'ChevronDown16';
export default ChevronDown16;
